import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useUserList = () => {
  const [data, setData] = useState();
  const getAllUsersList = async () => {
    // Fetch users list
    const list = await apiService.getAllUsers();
    list && setData(list); // update data state
    return list;
  };
  const getUsersList = async (params, associationtype) => {
    // Fetch users list
    const list = await apiService.userList(params, associationtype);
    list && setData(list); // update data state
    return list;
  };

  return {
    data,
    getUsersList,
    getAllUsersList,
  };
};
